import React, { useEffect, useState, useContext } from "react";
import AuthContext from "../../store/AuthContext";
import Live_Map from "../../components/LiveMap/Map";
import { fetchObjectives } from "../../utils/fecthObjectives";

export default function LiveMap() {
  const [coordinates, setCoordinates] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const authCtx = useContext(AuthContext);

  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;
  const endpoint = `${protocol}://${ip}:${port}/objectives`;

  useEffect(() => {
    async function loadCoordinates() {
      try {
        const objectives = await fetchObjectives({
          tokenID: authCtx.tokenID,
          refreshToken: authCtx.refreshToken,
          endpoint,
        });

        const coords = objectives
          .filter((obj) => {
            console.log("obj.hideOnMobile:", obj.hideOnMobile);
            return (
              obj.coordinates?.lat &&
              obj.coordinates?.lng &&
              obj.title &&
              obj.hideOnMobile !== "True" // filtro por string "True"
            );
          })
          .map((obj) => ({
            lat: obj.coordinates.lat,
            lng: obj.coordinates.lng,
            title: obj.title,
            description: obj.description,
          }));

        setCoordinates(coords);
      } catch (err) {
        console.error("Erro ao buscar objetivos:", err);
      }
    }

    loadCoordinates();
  }, []);

  return (
    <Live_Map
      objectiveCoordinates={coordinates}
      location={selectedLocation || [40.202000, -8.413313]} // valor default
      onLocationClick={(loc) => setSelectedLocation(loc)}
      onDoneClick={() => console.log("Feito! Local escolhido:", selectedLocation)}
    />
  );
}
